// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { folder16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-folder': IconFolder;
    }
}

/**
 * The icon component for the 'folder' icon
 */
export class IconFolder extends IconSvg {
    public constructor() {
        super(folder16X16);
    }
}

registerIconSvg('icon-folder', IconFolder);
export const iconFolderTag = 'nimble-icon-folder';
